// Include scss
import "../scss/index.scss";

// Images
import "./images.js";

/* 
    Libs 
*/

// Lazyload
import LazyLoad from "vanilla-lazyload";
var myLazyLoad = new LazyLoad();
myLazyLoad.update();

// Swiper
import Swiper from "swiper";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const swiper = new Swiper("#js-test-slider", {
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: {
    el: "#js-test-slider-pagination",
    clickable: true,
  },
});

// MagicScroll + GSAP
import ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap"; // What to import from gsap
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax); // Pass gsap import to Scrollmagic

var controller = new ScrollMagic.Controller();
var scene = new ScrollMagic.Scene({
  triggerElement: "#my-sticky-element-trigger",
  duration: "50%",
})
  .setTween("#my-sticky-element", {
    backgroundColor: "blue",
    scale: 0.7,
    x: "300px",
    rotate: 180,
  })
  .addTo(controller);

// Howler
import { Howl } from "howler";

window.addEventListener("DOMContentLoaded", () => {
  for (let slider of document.querySelectorAll(".js-case-sider-type-1")) {
    let progressObject = slider.querySelector(".js-case-sider-type-1__nav");
    let aboutText = slider.querySelector(".js-case-sider-type-1__text");

    new Swiper(slider, {
      modules: [Autoplay, Pagination, EffectFade],
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      effect: "fade",
      pagination: {
        el: slider.querySelector(".js-case-sider-type-1__nav"),
        clickable: true,
        bulletClass: "ucase-slider__navItem",
        bulletActiveClass: "ucase-slider__navItem_current",
        renderBullet: function (index, className) {
          return (
            '<div class="' +
            className +
            '">' +
            (index + 1) +
            '<div class="ucase-slider__navProgress"></div></div>'
          );
        },
      },
      autoplay: {
        delay: 3000,
      },
      fadeEffect: {
        crossFade: false,
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          for (let progressObj of progressObject.querySelectorAll(
            ".ucase-slider__navProgress"
          )) {
            progressObj.style.setProperty("width", 100 * (1 - progress) + "%");
          }
        },
        slideChange(swiper) {
          aboutText.innerHTML = swiper.slides[swiper.activeIndex].dataset.text;
        },
        afterInit: function (swiper) {
          aboutText.innerHTML = swiper.slides[swiper.activeIndex].dataset.text;
        },
      },
    });
  }

  for (let videoBlock of document.querySelectorAll(".js-fullvideo")) {
    let videoDesktop = videoBlock.querySelector(".js-video-d");
    let videoPlay = videoBlock.querySelector(".js-video-play");

    videoPlay.addEventListener("click", function (e) {
      e.stopPropagation();
      videoDesktop.play();
      videoPlay.style.display = "none";
    });

    videoDesktop.addEventListener("click", function (e) {
      e.stopPropagation();
      videoDesktop.pause();
      videoPlay.style.display = "block";
    });

    videoDesktop.addEventListener("pause", function () {
      videoPlay.style.display = "block";
    });

    window.addEventListener("resize", function () {
      if (this.window.innerWidth < 1240) {
        videoDesktop.pause();
        videoPlay.style.display = "block";
      }
    });
  }

  for (let audioItem of document.querySelectorAll(".js-audio-item")) {
    const state = {
      isPlaying: false,
    };

    const zeroPad = (value) => String(value).padStart(2, "0");
    const getRenderedTime = (seconds) => {
      const trackMin = Math.floor(seconds / 60);
      const trackSec = Math.floor(seconds % 60);
      return `${zeroPad(trackMin)}:${zeroPad(trackSec)}`;
    };

    const playButton = audioItem.querySelector(".js-audio-play");
    const playIcon = playButton.querySelector(".ucase-audio__icon-play");
    const pauseIcon = playButton.querySelector(".ucase-audio__icon-pause");

    const timeline = audioItem.querySelector(".js-audio-timeline");
    const timelineInput = audioItem.querySelector(".js-audio-timeline-input");
    const timeCurrent = audioItem.querySelector(".js-audio-time-current");
    const timeTotal = audioItem.querySelector(".js-audio-time-total");

    // SVG timeline
    const timelineWrapper = audioItem.querySelector(
      ".js-audio-progress-wrapper"
    );
    const timelineMask = audioItem.querySelector(".js-audio-progress-mask");
    const timelineCurrent = audioItem.querySelector(
      ".js-audio-progress-current"
    );
    const timelineRemaining = audioItem.querySelector(
      ".js-audio-progress-remaining"
    );

    const timelineWidth = timeline.clientWidth;

    timelineWrapper.setAttribute("width", timelineWidth);
    timelineWrapper.setAttribute("viewBox", `0 0 ${timelineWidth} 15`);
    timelineMask.setAttribute("width", timelineWidth);

    const audio = new Howl({
      src: audioItem.dataset.src,
      html5: true,
      onload: function () {
        const audioLengthInSeconds = audio._duration;

        timeTotal.textContent = getRenderedTime(audioLengthInSeconds);
        timelineInput.setAttribute("max", audioLengthInSeconds);
      },
    });

    const renderProgress = (seconds) => {
      const audioLengthInSeconds = audio._duration;
      const timelineWidth = timeline.clientWidth;
      const progressWidth = (seconds * timelineWidth) / audioLengthInSeconds;

      timelineCurrent.setAttribute("width", progressWidth);
      timelineRemaining.setAttribute("width", timelineWidth - progressWidth);
      timelineRemaining.setAttribute("x", progressWidth);
    };

    setInterval(() => {
      if (audio && state.isPlaying) {
        const seconds = audio.seek([]) || 0;

        timeCurrent.textContent = getRenderedTime(seconds);
        timelineInput.value = seconds;

        renderProgress(seconds);
      }
    }, 300);

    timelineInput.addEventListener("input", function () {
      const seconds = timelineInput.value;
      audio.seek(seconds);
      renderProgress(seconds);
      timeCurrent.textContent = getRenderedTime(seconds);
    });

    playButton.addEventListener("click", function () {
      if (state.isPlaying) {
        audio.pause();
        state.isPlaying = false;
        playIcon.style.display = "block";
        pauseIcon.style.display = "none";
      } else {
        audio.play();
        state.isPlaying = true;
        playIcon.style.display = "none";
        pauseIcon.style.display = "block";
      }
    });
  }
});
